
<div class="auth-wrapper">
    <div class="align-items-center grid h-full">
      <div class="col-6 h-full">
        <div class="gc-auth-leftPanel">
         <div class="gc-idnty-container">
          <div class="gc-logo">
              <a href=""><img src="../../assets/images/io-logo-green.svg" alt="io-logo.svg"></a>
            </div>
            <div class="">
              <p class="mt-5 ">{{logoText}}</p>
            </div>
          </div>
          <div class="gc-auth-slider">
            <!-- <app-multi-slider></app-multi-slider> -->
            <img src="../../assets/images/banner.svg" alt="banner.svg">
          </div>
          </div>
      </div>
      <div class="col-6 relative justify-content-center flex align-items-center h-full">

        <div class="gc-auth-form-container">
          <div class="flex justify-content-center">
          <img src="../../../../assets/images/successful.gif" alt="successful.gif">
          </div>
          <h1>Password Reset Done</h1>
            <div class="mt-1 mb-5">
            <button type="submit" (click)="navigateToLogin()"  class="login-btn">Login Now</button>
        </div>
      </div>
        <app-footer></app-footer>
  </div>
  </div>

